/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  Strucutre:
          url     => router path
          name    => name to display in sidebar
          slug    => router path name
          icon    => Feather Icon component/icon name
          tag     => text to display on badge
          tagColor  => class to apply on badge element
          i18n    => Internationalization
          submenu   => submenu of current item (current item will become dropdown )
                NOTE: Submenu don't have any icon(you can add icon if u want to display)
          isDisabled  => disable sidebar item/group
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default [
  {
    url: '/user/all',
    title: 'Users',
    slug: 'users',
    i18n: 'Users',
    icon: 'people'
  },
  {
    url: '/work-hours/all',
    title: 'Work hours',
    slug: 'work-hours',
    i18n: 'WorkHours',
    icon: 'alarm'
  },
  {
    url: '/report/daily',
    title: 'Daily reports',
    slug: 'daily-reports',
    i18n: 'DailyReport',
    icon: 'list'
  },
  {
    url: '/report/dailyCashier',
    title: 'Daily cashier reports',
    slug: 'daily-cashier-reports',
    i18n: 'DailyCashierReport',
    icon: 'list'
  },
  {
    url: '/report/workHourDiary',
    title: 'Work hour diary',
    slug: 'work-hour-diaries',
    i18n: 'WorkHourDiary',
    icon: 'list'
  },
  {
    url: '/report/automaticCashRegister',
    title: 'Automatic cash register report',
    slug: 'automatic-cash-register-reports',
    i18n: 'AutomaticCashRegisterReport',
    icon: 'list',
    Title: 'Test title'
  },
  {
    url: '/monthly-working-hours/all',
    title: 'Monthly working plan',
    slug: 'monthly-working-plan',
    i18n: 'MonthlyWorkingHours',
    icon: 'calendar_today'
  },
  {
    url: '/holiday-plan/all',
    title: 'Holiday plan',
    slug: 'holiday-plan',
    i18n: 'HolidayPlan',
    icon: 'calendar_today'
  },
  {
    url: '/shift/all',
    title: 'Shifts',
    slug: 'shifts',
    i18n: 'Shifts',
    icon: 'alarm'
  },
  {
    url: '/holiday/all',
    title: 'Holiday',
    slug: 'holiday',
    i18n: 'Holidays',
    icon: 'calendar_today'
  }
]
